var $ = require('jquery');
var jQueryBridget = require('jquery-bridget');
var Isotope = require('isotope-layout');
var imagesLoaded = require('imagesloaded');

module.exports = (function () {
  // make Isotope a jQuery plugin
  jQueryBridget('isotope', Isotope, $);
  imagesLoaded.makeJQueryPlugin($);

  var block = '.js-isotope';

  /* Dom elements */
  var dom = {
    container: block+'__grid-container',
    grid: block+'__grid',
    gridItem: block+'__item',
    gutter: block+'__grid-gutter',
    loadMore: block+'__load-more'
  };

  /* Grid options */
  var isotopeOptions = {
    itemSelector: dom.gridItem,
    layoutMode: 'fitRows',
    fitRows: {
      gutter: dom.gutter
    }
  };

  var loadMore = function(that, $grid){
    var $btn = $(that);
    $btn.addClass('disabled');

    var next = $btn.data('next-page');
    var loadMoreFunction = $grid.data('load-function');
    $.get('/stage-ajax/'+loadMoreFunction+'/?&stage-language=en_GB', { start: next }, function (response) {
      var $newItems = $(response.wall);

      // Insert new elements
      $grid.isotope('insert', $newItems);

      if (response.next) {
        $btn.data('next-page', response.next);
        $btn.removeClass('disabled');
      } else {
        $btn.fadeOut();
      }
    });
  };

  var init = function () {
    // Initialize grids
    $.each($(dom.grid), function (k, grid) {
      var $grid = $(grid);

      $grid.imagesLoaded(function () {
        // Initialize isotope grid
        $grid.isotope(isotopeOptions);
      });

      $grid.closest(dom.container).find(dom.loadMore).not('.disabled').on('click', function () {
        loadMore(this, $grid);
      });
    });
  };

  return {
    init: init
  };
})();
